/**
 * Real API implementation for Auth.
 * getCurrentUser fetches the authenticated user (Bearer token sent by apiClient).
 */

import { apiClient } from '../apiClient';

const V3_USERS_ME_PATH = '/api/v3/users/me';

export const getCurrentUser = async () => {
  const response = await apiClient.get(V3_USERS_ME_PATH);
  return response.data;
};
